import React from 'react';
import { Route, Redirect } from 'react-router-dom';

const PrivateRoute = ({component: Component, authorization, redirectUrl, ...rest}) => {
    return (
        <Route {...rest} render={props => (
            authorization ?
                <Component {...props} />
            : <Redirect to={redirectUrl} />
        )} />
    );
};

export default PrivateRoute;